import React, {Component} from 'react';
import {Translation} from 'react-i18next';

import SubRegionForm from '../containers/SubRegionFormContainer';
import DocumentHead from '../../../../elements/components/DocumentHead';
import Logger from '../../../../../../lib/Logger';

class SubRegionAddScreen extends Component {

  scrollToTop = () => {
    Logger.log('debug', `SubRegionAdd.scrollToTop()`);
    if (typeof window !== 'undefined') {
      setTimeout(() => window.scrollTo(0, 0), 100);
    }
  }

  render() {
    return (
      <Translation>{(t) => 
        <div>
          <DocumentHead title={t('subregion_route_add')} />
          <SubRegionForm />
        </div>
      }</Translation>
    )
  }

  /* LIFECYCLE EVENTS */

  componentDidMount() {
    this.scrollToTop();
  }
}

export default SubRegionAddScreen;

Logger.log('silly', `SubRegionAddScreen loaded.`);
